import { Moment } from '@seiue/moment'
import { isArray } from '@seiue/util'
import moment from 'moment'
import { DateTypeEnum } from 'packages/sdks-next/growp'

import { NumberRangeValue } from '../DataTable/types'

import { RangeObjectValue } from './type'

/**
 * moment转化为指定格式的字符串
 * @param momentData - moment
 * @param type - 类型
 * @returns 转化后的字符串
 */
export const momentToString = (
  momentData: Moment | null,
  type?: DateTypeEnum
) => {
  if (momentData && moment.isMoment(momentData)) {
    const format =
      type === DateTypeEnum.Time ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
    return momentData.format(format)
  }
  return undefined
}

/**
 * 字符串时间转化为moment时间
 * @param str - 字符串
 * @param type - 类型
 * @returns moment时间
 */
export const stringToMoment = (str?: string, type?: DateTypeEnum) => {
  const format = type === DateTypeEnum.Time ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
  if (str && moment(str, format, true).isValid()) {
    return moment(str)
  }
  return null
}

/**
 * moment时间范围转化为lt,rt对象时间范围
 * @param rangeData - moment时间范围
 * @param type - 类型
 * @returns lt,rt时间范围
 */
export const momentRangeToObjectRange = (
  rangeData?: [Moment | null, Moment | null] | null,
  type?: DateTypeEnum
) => {
  if (
    isArray(rangeData) &&
    rangeData.length === 2 &&
    rangeData[0] &&
    rangeData[1]
  ) {
    return {
      lt: momentToString(rangeData[0], type),
      rt: momentToString(rangeData[1], type),
    }
  }
  return undefined
}

/**
 * lt,rt时间范围转化为moment时间范围
 * @param rangeStr - lt,rt时间范围
 * @param type - 类型
 * @returns moment时间范围
 */
export const objectRangeToMomentRange = (
  rangeObj?: RangeObjectValue,
  type?: DateTypeEnum
): [Moment | null, Moment | null] => {
  if (rangeObj && rangeObj.lt && rangeObj.rt) {
    return [
      stringToMoment(rangeObj.lt, type),
      stringToMoment(rangeObj.rt, type),
    ]
  }
  return [null, null]
}

/**
 * 判断是否是时间范围-{ lt: ***, rt: *** }
 *
 * @param val - 任意格式数据
 * @returns - 判断结果
 */
export const isRangeObjectValue = (val: unknown) => {
  const formats = ['YYYY-MM-DD', 'YYYY-MM-DD HH:mm']
  return (
    typeof val === 'object' &&
    val !== null &&
    typeof (val as RangeObjectValue).lt === 'string' &&
    typeof (val as RangeObjectValue).rt === 'string' &&
    moment((val as RangeObjectValue).lt, formats).isValid() &&
    moment((val as RangeObjectValue).rt, formats).isValid()
  )
}
